import { useState } from 'react';
import { Worker, WorkerDocument } from 'app/types/worker';
import { useUpdateDocumentMutation, useUploadDocumentFileMutation } from 'app/services/workers';
import DocumentForm, { toApiDate } from './Form';

type EditDocumentProps = {
  document: WorkerDocument;
  worker: Worker;
};

const EditDocument = ({ document, worker }: EditDocumentProps) => {
  const [ update, documentMeta ] = useUpdateDocumentMutation();
  const [ uploadFile, fileMeta ] = useUploadDocumentFileMutation();
  const [ meta, setMeta ] = useState<any>({ isSuccess: false, data: {} });

  const handleSubmit = async (values: any) => {
    const fileList = values.File as any[] | undefined;
    const first = fileList?.[0];

    await update({
      Id: document.Id,
      DocumentTypeId: values.DocumentTypeId,
      ValidFrom: toApiDate(values.ValidFrom),
      ValidTo: toApiDate(values.ValidTo),
      RemoveFile: !!fileList && fileList.length === 0,
    } as any).unwrap();

    if (first?.originFileObj && first.status !== 'done' && first.status !== 'error') {
      // No unwrap: a failed upload doesn't undo the save, the exceptions middleware shows its toast.
      await uploadFile({ documentId: document.Id, file: first.originFileObj });
    }

    setMeta({ isSuccess: true, data: { Id: document.Id } });
  };

  return <DocumentForm
    handleSubmit={handleSubmit}
    document={document}
    unitId={worker.UnitId}
    meta={{
      isSuccess: meta.isSuccess,
      isLoading: documentMeta.isLoading || fileMeta.isLoading,
      isError: documentMeta.isError,
      error: documentMeta.error,
      data: meta.data
    }}
  />;
};

export default EditDocument;
